import { render, staticRenderFns } from "./BlockActivities.vue?vue&type=template&id=7be15541&"
import script from "./BlockActivities.vue?vue&type=script&lang=js&"
export * from "./BlockActivities.vue?vue&type=script&lang=js&"
import style0 from "./BlockActivities.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports